import React, { useRef, useState } from "react";
import loginVid from "../assets/login.mp4";
import logo from "../assets/appnest_logo.png";
import InputField from "../component/InputField";
import ButtonCompo from "../component/ButtonCompo";
import axios from "axios";
import { SERVER_URL } from "../constant";
import { LinearProgress } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useNavigate } from "react-router-dom";
import AlertBox from "../component/AlertBox";
import { useForm } from "react-hook-form";
import DialogBox from "../component/DialogBox";
import { BsCheckCircle } from "react-icons/bs";

function CompanySignup() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [enableOtpField, setEnableOtpField] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(undefined);
  const [message, setMessage] = useState("");
  const [enableCompanyForm, setEnableCompanyForm] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [signupPhoneError, setSignupPhoneError] = useState(undefined)

  async function registerPhone() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/verify/otp/generate/${phoneNumber}`,
        method: "get",
      });
      setOpen(true);
      setSuccess(true);
      setMessage("OTP has been sent");
      setEnableOtpField(true);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("OTP sent failed");
      setEnableOtpField(false);
    } finally {
      setLoading(false);
    }
  }

  async function verifyOTP() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/verify/otp/verify/${phoneNumber}/${otp}`,
        method: "get",
        withCredentials: true,
      });
      setEnableOtpField(false);
      setEnableCompanyForm(true);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  async function companyForm(data) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/add`,
        method: "post",
        data: data,
        withCredentials: true,
      });
      setEnableCompanyForm(false);
      handleAlertOpen();
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  const handleChange = (newValue) => {
    setOtp(newValue);
  };

  const alertRef = useRef(null);

  const handleAlertOpen = () => {
    if (alertRef.current) {
      alertRef.current.handleOpen();
    }
  };

  const handlePhoneChange = (number) => {
    if(number?.length < 10 || number?.length > 10) {
      setSignupPhoneError({message : "Phone number should contain 10 digits"})
      return null
    }
    setSignupPhoneError(undefined)
    setPhoneNumber(number)
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex items-center justify-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <DialogBox maxWidth="xs" ref={alertRef} closeActionButton="CLOSE">
          <p className="text-[20px] font-medium">Thank Your For Choosing Us</p>
          <div className="text-center w-full flex justify-center items-center mt-3">
            <BsCheckCircle className="text-green-600 text-[35px]" />
          </div>
          <p className="mt-3 text-slate-500">
            We have recived your application. We will look into this and will
            get back to you soon. Thank you.
          </p>
        </DialogBox>
        <div className="w-1/2 hidden lg:flex h-[100vh]">
          <video
            src={loginVid}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          />
        </div>
        <div className="w-full lg:w-1/2 flex flex-col justify-center items-center ">
          <img src={logo} className="w-[10rem] mb-[3rem] pt-5" alt="" />
          {enableOtpField === true ? (
            <div className="w-[20rem] flex flex-col justify-center items-center">
              <div className="text-left w-full mb-5">
                <p className="text-[23px] font-semibold">OTP Verification</p>
                <span className="text-[15px] text-slate-500">
                  Please verify the OTP that has been to {phoneNumber}
                </span>
              </div>
              <MuiOtpInput
                value={otp}
                length={6}
                className="!gap-[2px]"
                onChange={handleChange}
              />
              <ButtonCompo
                variant="contained"
                className="!mt-5 w-full"
                onClick={verifyOTP}
              >
                Verify
              </ButtonCompo>
            </div>
          ) : enableCompanyForm === true ? (
            <div className="w-full flex flex-col justify-center items-center px-10 py-5">
              <div className="text-left w-full mb-5">
                <p className="text-[23px] font-semibold">
                  Company Onboarding Form
                </p>
                <span className="text-[15px] text-slate-500">
                  Please enter the all details below. Every field is required.
                </span>
              </div>
              <form
                className="w-full mt-5"
                onSubmit={handleSubmit(companyForm)}
              >
                <div className="w-full space-y-5">
                  <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <InputField
                      label="Business Name"
                      {...register("name", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.name}
                    />
                    <InputField
                      label="Business Email ID"
                      {...register("companyEmail", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.companyEmail}
                    />
                    <InputField
                      label="Business Website"
                      {...register("companyWebsite", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.companyWebsite}
                    />
                    <InputField
                      label="Total Employees"
                      {...register("totalEmployees", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.totalEmployees}
                    />
                  </div>
                  <div>
                    <InputField
                      label="Street Address"
                      {...register("streetAddress", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.streetAddress}
                    />
                  </div>
                  <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <InputField
                      label="Plot No."
                      {...register("plotNo", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.plotNo}
                    />
                    <InputField
                      label="Pincode"
                      {...register("pincode", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        minLength: {
                          value: 6,
                          message: "Pincode should not be less than 6 digits"
                        },
                        maxLength: {
                          value: 6,
                          message: "Pincode should not be greater than 6 digits"
                        },
                        setValueAs: (value) => value.trim(),
                      })}
                      error={errors?.pincode}
                    />
                    <InputField
                      label="State"
                      {...register("state", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.state}
                    />
                    <InputField
                      label="Country"
                      {...register("country", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.country}
                    />
                    <InputField
                      label="Your Name"
                      {...register("superadminName", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.superadminName}
                    />
                    <InputField
                      label="Your Phone Number"
                      {...register("superadminPhone", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        minLength: {
                          value: 10,
                          message: "Phone number should not be less than 10 digits"
                        },
                        maxLength: {
                          value: 10,
                          message: "Phone number should not be greater than 10 digits"
                        },
                        setValueAs: (value) => value.trim(),
                      })}
                      error={errors?.superadminPhone}
                    />
                    <InputField
                      label="Your Email ID"
                      {...register("superadminEmail", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.superadminEmail}
                    />
                    <InputField
                      label="Password"
                      {...register("password", {
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      })}
                      error={errors?.password}
                    />
                  </div>
                </div>
                <ButtonCompo
                  variant="contained"
                  className="!mt-5"
                  type="submit"
                >
                  Register
                </ButtonCompo>
              </form>
            </div>
          ) : (
            <div className="w-[20rem] flex flex-col justify-center items-center">
              <div className="text-left w-full mb-5">
                <p className="text-[23px] font-semibold">
                  Welcome To AppNest People
                </p>
                <span className="text-[15px] text-slate-500">
                  Please verify your business phone number to proceed to further
                  steps.
                </span>
              </div>
              <InputField
                label="Business Phone Number"
                onChange={(e) => handlePhoneChange(e?.target?.value)}
                error={signupPhoneError}
              />
              <ButtonCompo
                variant="contained"
                className="!mt-5 w-full"
                onClick={registerPhone}
              >
                Register
              </ButtonCompo>
              <span className="mt-2 text-[13px] text-slate-600">OR</span>
              <ButtonCompo
                variant="outlined"
                className="!mt-2 w-full"
                href="/superadmin/signin"
              >
                Login
              </ButtonCompo>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default CompanySignup;
